<template>
  <div>
    <div :class="$b('products')">
      <sg-link
        v-for="product in products"
        :key="product.baseSku"
        :to="`/owners/${product.baseSku}`"
        class="product"
      >
        <div :class="$b('product')">
          <div :class="$b('product-image-wrapper')">
            <dynamic-img
              :class="$b('product-image')"
              :width="800"
              :height="800"
              :sku="product.sku"
            />
          </div>
          <BaseCopy
            size="h3"
            :class="$b('product-title')"
          >
            {{ product.title }}
          </BaseCopy>
        </div>
      </sg-link>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'OwnersManualListing',

  props: {
    products: {
      type: Array,
      required: true
    }
  },

  setup() {
    const { getTitle, getDescription } = useMetaHelper()

    useHead({
      title: getTitle('SunGod Owners Guides'),
      meta: [
        ...getDescription('Instructions for the use and care of your SunGod products.'),
        { hid: 'og:title', property: 'og:title', content: getTitle('SunGod Owners Guides') }
      ]
    })
  }
})
</script>

<style lang="postcss">
.OwnersManualListing {
  @apply mt-sm;
}

.OwnersManualListing__products {
  @apply
    grid grid-cols-2 md:grid-cols-3 gap-sm md:gap-md
    mb-md mt-sm;
}

.OwnersManualListing__product-image-wrapper {
  @apply rounded-md overflow-hidden;
}

.OwnersManualListing__product-image {
  @apply transition;
  transform: translateZ(0) scale(1);

  .OwnersManualListing__product:hover & {
    transform: translateZ(0) scale(1.05);
  }
}

.OwnersManualListing__product-title {
  @apply pt-xxxs;
}
</style>
